var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBingoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.338 12.622c.189 0 .34.033.452.097.113.061.194.15.245.263.054.115.08.251.08.408a.738.738 0 01-.084.351.595.595 0 01-.266.251 1.083 1.083 0 01-.487.093h-.968v-1.463h1.028zM12.037 10.251c.22 0 .4.026.537.076.14.048.244.124.309.23a.798.798 0 01.098.419c0 .15-.033.277-.098.377a.582.582 0 01-.3.231c-.138.05-.324.075-.555.075h-.718v-1.408h.727z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5a7 7 0 110 14 7 7 0 010-14zm-1.133 4a1 1 0 00-1 1v4.1a1 1 0 001 1h1.452c.508 0 .934-.067 1.278-.202.343-.134.601-.334.773-.602.175-.268.263-.603.263-1.002 0-.234-.052-.46-.156-.674a1.177 1.177 0 00-.52-.52 1.272 1.272 0 00-.3-.115c.053-.02.104-.044.15-.069.252-.137.43-.314.538-.532.107-.218.16-.451.16-.7 0-.284-.054-.532-.164-.742a1.397 1.397 0 00-.483-.527 2.236 2.236 0 00-.76-.31A4.503 4.503 0 0012.078 9h-1.21z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: "currentColor"
  })));
}
SvgBingoFilled.displayName = 'BingoFilled';
export default SvgBingoFilled;